<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" type="triangle-skew-spin" [fullScreen]="false">
    <p style="color: white"> Loading... </p>
</ngx-spinner>
<div class="content-wrapper">
    <!-- content here -->
    <div class="col-md-12">
        <div class="card">
            <div class="row justify-content-md-center card-header bg-primary"> รายการขอเพิ่ม Barcode
                <div class="col-md-auto">
                </div>
                <div class="col-md-auto">
                    <mat-form-field appearance="fill">
                        <mat-label>ช่วงวันที่จะขอ</mat-label>
                        <mat-date-range-input [rangePicker]="picker" disabled color="accent">
                            <input matStartDate [ngModelOptions]="{standalone: true}" [(ngModel)]="inDate[0]"
                                placeholder="เริ่มวันที่">
                            <input matEndDate [ngModelOptions]="{standalone: true}" [(ngModel)]="inDate[1]"
                                placeholder="ถึงวันที่">
                        </mat-date-range-input>
                        <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    </mat-form-field>
                </div>
                <div class="col-md-auto">
                    <button mat-raised-button color="accent" (click)="Loadbarcodelist()">ค้นหา/โหลดใหม่</button>
                </div>
                <div class="col-2">
                    <input type="text" class="form-control" placeholder="Search Here" [(ngModel)]="txtSearch">
                </div>
            </div>
            <div class="card-body table-responsive p-2" style="height: 600px">
                <table class="table table-sm table-striped table-hover table-head-fixed table-bordered text-nowrap"
                    style="width:100%">
                    <thead>
                        <tr>
                            <th style="text-align:center">ลำดับ</th>
                            <th style="text-align:center" scope="col">วันที่ขอ</th>
                            <th style="text-align:center" scope="col">โซน</th>
                            <th style="text-align:center" scope="col">กลุ่ม</th>
                            <th style="text-align:center" scope="col">ผู้ขอ</th>
                            <th scope="col">เลขแปลง</th>
                            <th scope="col">เจ้าของแปลง</th>
                            <th scope="col">หมายเหตุ</th>
                            <th style="text-align:center" scope="col">คิวที่ขอ</th>
                            <th style="text-align:center" scope="col">คิวปัจุบัน</th>
                            <th style="text-align:center" scope="col">คิวที่ขอแล้ว</th>
                            <th style="text-align:center" scope="col">สถานะ</th>
                            <th style="text-align:center" scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of codelist | filter:txtSearch ; let i=index">
                            <td style="text-align:center">{{i+1 | number}}</td>
                            <td style="text-align:center">{{THtoLocalstring(item.created_at)}}</td>
                            <td style="text-align:center">{{item.supzone}}</td>
                            <td style="text-align:center">{{item.groupCode}}</td>
                            <td style="text-align:center">{{item.Requester_nane}}</td>
                            <td>{{item.landno}}</td>
                            <td>{{item.fmname}}</td>
                            <td>{{item.comment}}</td>
                            <td style="text-align:center">{{item.num_qcard}}</td>
                            <td style="text-align:center">{{item.qcard}}</td>
                            <td style="text-align:center">{{item.qcard_adj}}</td>
                            <td style="text-align:center">{{item.status_desc}}</td>
                            <td style="text-align:center">
                                <div *ngIf="item.status == 0">
                                    <button class="btn btn-success btn-sm"
                                        [disabled]="item.Partcode != userdata.zonedata" (click)="AcceptBarcode(item)">
                                        <i class="fas fa-check"></i> อนุมัติ</button>
                                    <button class="btn btn-danger btn-sm"
                                        [disabled]="item.Partcode != userdata.zonedata"
                                        (click)="disAcceptBarcode(item.id)">
                                        <i class="fas fa-window-close"></i> ไม่อนุมัติ</button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <!-- content here -->
</div>
<app-footer></app-footer>